import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

/**
 * Shown in the last ~60s before the inactivity auto-logout fires. Not
 * dismissible via backdrop click/Escape -- the user must actively choose to
 * stay logged in, otherwise the idle timer's own logout is the only exit.
 *
 * The passive activity listener in `useIdleLogout` is short-circuited while
 * this modal is open, so mouse movement toward the button will not silently
 * dismiss it -- only the explicit click on "Stay logged in" resets the timer.
 */
const IdleLogoutWarningDialog = ({ secondsRemaining, onStayLoggedIn }) => {
  const open = secondsRemaining != null;

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onStayLoggedIn();
        }
      }}
      PaperProps={{
        sx: {
          width: 320,
          maxWidth: '90vw',
          borderRadius: 2,
          backgroundImage: 'none',
        },
      }}
    >
      <DialogTitle
        sx={{
          px: 2,
          pt: 1.5,
          pb: 0.5,
          fontSize: '0.95rem',
          fontWeight: 600,
          lineHeight: 1.3,
        }}
      >
        Still there?
      </DialogTitle>
      <DialogContent sx={{ px: 2, pt: 0.5, pb: 1.25 }}>
        <Typography sx={{ fontSize: '0.8rem', color: 'text.secondary', lineHeight: 1.4 }}>
          You'll be logged out in {open ? secondsRemaining : 0}s due to inactivity.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pt: 0, pb: 1.5 }}>
        <Button
          variant="contained"
          size="small"
          onClick={onStayLoggedIn}
          autoFocus
          sx={{ textTransform: 'none', fontWeight: 600, px: 1.5 }}
        >
          Stay logged in
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleLogoutWarningDialog;
